(() => {
    if (document.body.classList.contains('post-type-archive-nr_music')) {
        new ScrollDown(document.body);
        new InViewAnimation();

        initSideScroll();
        initHighlightArrows();
    }

    function initSideScroll() {
        const buttons = document.querySelectorAll('.jsSideYears button');

        inView.offset({
            top: window.innerHeight / 2,
            bottom: window.innerHeight / 2
        });

        window.addEventListener('resize', _ => {
            inView.offset({
                top: window.innerHeight / 2,
                bottom: window.innerHeight / 2
            });
        });

        inView('.jsDiscoGridYear')
            .on('enter', el => {
                for (let i = 0; i < buttons.length; i++) buttons[i].classList.remove('active');

                const element = document.querySelector('.jsSideYears button[data-year-trigger="' + el.dataset.year + '"]');
                if (element) element.classList.add('active');
            })
        ;

        Array.prototype.forEach.call(buttons, el => {
            el.addEventListener('click', e => {
                e.preventDefault();

                const trigger = el.dataset.yearTrigger;
                const triggerEl = document.querySelector('[data-year="' + trigger + '"]');
                const offset = triggerEl.getBoundingClientRect();

                TweenLite.to(window, 0.8, { scrollTo: (offset.top + window.scrollY) - 100, ease: Power2.easeInOut });
            });
        });
    }

    function initHighlightArrows() {
        const elements = document.querySelectorAll('.jsHighlightSongImg');
        
        Array.prototype.forEach.call(elements, el => {
            const arrow = el.querySelector('.jsHighlightSongArrow');

            el.addEventListener('mouseenter', _ => {
                TweenLite.to(arrow, 0.5, { opacity: 1, ease: Power2.easeInOut });
            });

            el.addEventListener('mouseleave', _ => {
                if (el.parentElement.parentElement.classList.contains('highlight-song--even')) {
                    TweenLite.to(arrow, 1.5, { bottom: '18%', left: 22, ease: Power2.easeOut });
                }
                else {
                    TweenLite.to(arrow, 1.5, { right: 20, bottom: '18%', ease: Power2.easeOut });
                }
            });

            el.addEventListener('mousemove', e => {
                const elWidth = el.offsetWidth;
                const elHeight = el.offsetHeight;
                const mouseX = e.layerX;
                const mouseY = e.layerY;

                if (el.parentElement.parentElement.classList.contains('highlight-song--even')) {
                    const left = e.layerX;
                    const bottom = elHeight - mouseY - arrow.offsetHeight;

                    TweenLite.to(arrow, 0.8, { bottom: bottom, left: left, ease: Power2.easeOut });
                }

                else {
                    const right = elWidth - mouseX - arrow.offsetWidth;
                    const bottom = elHeight - mouseY - arrow.offsetHeight;

                    TweenLite.to(arrow, 0.8, { right: right, bottom: bottom, ease: Power2.easeOut });
                }
            });
        });
    }
})();